export enum AssetViewTabs {
	ASSET_DETAILS = 'Asset Details',
	HEROES = 'Heroes',
	CHATS = 'Chats',
	CHAPTERS = 'Chapters',
	STORIES = 'Stories',
	ALTERNATIVE_CLOTHES = 'Alternative Clothes',
	ALTERNATIVE_BACKGROUNDS = 'Alternative Backgrounds',
}
